export const SET_LOADING_DATA = '@clientVisit/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@clientVisit/SET_LOADING_SELECTS';
export const SET_LOADING_MODAL_FEEDBACK = '@clientVisit/SET_LOADING_MODAL_FEEDBACK';

export const GET_ALL_REQUEST = '@clientVisit/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@clientVisit/GET_ALL_SUCCESS';

export const GET_ALL_SELECTS_REQUEST = '@clientVisit/GET_ALL_SELECTS_REQUEST';
export const GET_ALL_SELECTS_SUCCESS = '@clientVisit/GET_ALL_SELECTS_SUCCESS';

export const GET_ID_MODAL_FEEDBACK_REQUEST = '@clientVisit/GET_ID_MODAL_FEEDBACK_REQUEST';
export const GET_ID_MODAL_FEEDBACK_SUCCESS = '@clientVisit/GET_ID_MODAL_FEEDBACK_SUCCESS';

export const SHARE_CSV = '@clientVisit/SHARE_CSV';

export const SET_PAGE = '@clientVisit/SET_PAGE';
export const SET_ROWS_COUNT = '@clientVisit/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@clientVisit/SET_ROWS_PER_PAGE';
export const SET_ROWS_ORIENTATION = '@clientVisit/SET_ROWS_ORIENTATION';
export const SET_ORDER = '@clientVisit/SET_ORDER';
export const SET_ORDERBY = '@clientVisit/SET_ORDERBY';

export const SEARCH = '@clientVisit/SEARCH';
